import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { OrganisationRole } from "../interfaces/organisation.interface";
import { queryParamString } from "../utils/query-param-string";
import { ApiService } from "./api.service";

@Injectable({ providedIn: 'root' })

export class OrganisationRoleService {
    public constructor(private readonly api: ApiService) {}

  public get(admin = false): Observable<OrganisationRole[]> {
    return this.api.get<OrganisationRole[]>(
      queryParamString(admin ? `admin/organisations/roles` : `organisations/roles`),
    );
  }
}